/** Resolve the shared map API host from the consuming application's Vite settings. */
export const resolveApiBaseUrl = (env: {
  VITE_APP_API_BASE_URL?: string
  VITE_API_BASE_URL?: string
}): string =>
  env.VITE_APP_API_BASE_URL || env.VITE_API_BASE_URL || 'https://api.popety.io'
